// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.utilisateur_compte_container {
    display: flex;
    flex-direction: column;
    padding-left: 20%;
    padding-right: 20%;
    padding-top: 5%;
}

.utilisateur_compte_header {
    text-align: center;
}

.utilisateur_compte_header h1 {
    font-size: 32px;
    font-weight: 700;
}

.utilisateur_compte_header p {
    font-size: 16px;
    font-weight: 500;
    color: var(--couleur-principale);
}

.utilisateur_compte_menu {
    display: flex;
    justify-content: center;
    flex-direction: column;
}

.utilisateur_compte_menu_item {
    display: flex;
    align-items: center;
    padding: 10px 0px;
    border-bottom: solid 1px var(--gris-secondaire);
    border-radius: 10px;
    cursor: pointer;
    transition: background-color 0.3s ease;
    color: var(--gris-principale);
}

.utilisateur_compte_menu_item i {
    font-size: 24px;
    margin-right: 15px;
}

.utilisateur_compte_menu_item span {
    font-size: 16px;
    font-weight: 700;
}

.utilisateur_compte_action button {
    color: var(--white-principale);
    background-color: var(--violet-principale);
    border: solid 1px var(--violet-principale);
    border-radius: 100px;
    width: 100%;
    padding: 14px;
    display: flex;
    justify-content: center;
    align-items: center;
}

.utilisateur_compte_action span {
    color: var(--white-principale);
    font-size: 15px;
    font-weight: 700;
}

.utilisateur_compte_action i {
    margin-right: 10px;
    font-size: 24px;
}

.utilisateur_compte_action button:hover {
    background-color: var(--couleur-secondaire);
    border: solid 1px var(--couleur-secondaire);
    cursor: pointer;
}

.utilisateur_compte_notification {
    width: 30px;
    height: 30px;
    background-color: var(--couleur-secondaire);
    color: var(--white-principale);
    border: solid 1px var(--couleur-secondaire);
    border-radius: 50%;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-left: 20px;

}


.utilisateur_compte_separator {
    margin: 15px 0;
    border: none;
    border-top: 1px solid var(--couleur-dark);
}

.admin_menu_title {
    font-size: 30px;
    font-weight: 700;
    color: var(--couleur-dark);
    margin-bottom: 5px;
    text-align: center;
}`, "",{"version":3,"sources":["webpack://./src/assets/css/utilisateur/utilisateurCompte.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,sBAAsB;IACtB,iBAAiB;IACjB,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,gCAAgC;AACpC;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,sBAAsB;AAC1B;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,iBAAiB;IACjB,+CAA+C;IAC/C,mBAAmB;IACnB,eAAe;IACf,sCAAsC;IACtC,6BAA6B;AACjC;;AAEA;IACI,eAAe;IACf,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,8BAA8B;IAC9B,0CAA0C;IAC1C,0CAA0C;IAC1C,oBAAoB;IACpB,WAAW;IACX,aAAa;IACb,aAAa;IACb,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,8BAA8B;IAC9B,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,2CAA2C;IAC3C,2CAA2C;IAC3C,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,2CAA2C;IAC3C,8BAA8B;IAC9B,2CAA2C;IAC3C,kBAAkB;IAClB,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,iBAAiB;;AAErB;;;AAGA;IACI,cAAc;IACd,YAAY;IACZ,yCAAyC;AAC7C;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,0BAA0B;IAC1B,kBAAkB;IAClB,kBAAkB;AACtB","sourcesContent":[".utilisateur_compte_container {\n    display: flex;\n    flex-direction: column;\n    padding-left: 20%;\n    padding-right: 20%;\n    padding-top: 5%;\n}\n\n.utilisateur_compte_header {\n    text-align: center;\n}\n\n.utilisateur_compte_header h1 {\n    font-size: 32px;\n    font-weight: 700;\n}\n\n.utilisateur_compte_header p {\n    font-size: 16px;\n    font-weight: 500;\n    color: var(--couleur-principale);\n}\n\n.utilisateur_compte_menu {\n    display: flex;\n    justify-content: center;\n    flex-direction: column;\n}\n\n.utilisateur_compte_menu_item {\n    display: flex;\n    align-items: center;\n    padding: 10px 0px;\n    border-bottom: solid 1px var(--gris-secondaire);\n    border-radius: 10px;\n    cursor: pointer;\n    transition: background-color 0.3s ease;\n    color: var(--gris-principale);\n}\n\n.utilisateur_compte_menu_item i {\n    font-size: 24px;\n    margin-right: 15px;\n}\n\n.utilisateur_compte_menu_item span {\n    font-size: 16px;\n    font-weight: 700;\n}\n\n.utilisateur_compte_action button {\n    color: var(--white-principale);\n    background-color: var(--violet-principale);\n    border: solid 1px var(--violet-principale);\n    border-radius: 100px;\n    width: 100%;\n    padding: 14px;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n}\n\n.utilisateur_compte_action span {\n    color: var(--white-principale);\n    font-size: 15px;\n    font-weight: 700;\n}\n\n.utilisateur_compte_action i {\n    margin-right: 10px;\n    font-size: 24px;\n}\n\n.utilisateur_compte_action button:hover {\n    background-color: var(--couleur-secondaire);\n    border: solid 1px var(--couleur-secondaire);\n    cursor: pointer;\n}\n\n.utilisateur_compte_notification {\n    width: 30px;\n    height: 30px;\n    background-color: var(--couleur-secondaire);\n    color: var(--white-principale);\n    border: solid 1px var(--couleur-secondaire);\n    border-radius: 50%;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    margin-left: 20px;\n\n}\n\n\n.utilisateur_compte_separator {\n    margin: 15px 0;\n    border: none;\n    border-top: 1px solid var(--couleur-dark);\n}\n\n.admin_menu_title {\n    font-size: 30px;\n    font-weight: 700;\n    color: var(--couleur-dark);\n    margin-bottom: 5px;\n    text-align: center;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
